import styled from "styled-components";

const DetailStyle = styled.button`
background-color: #4CAF50;
border: none;
color: black;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 14px;
width: 90px;
height: 50px;
border-radius: 2px;
cursor:pointer;
`;


export default DetailStyle;
